import React, { FC, useEffect } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import { useNonSpammyFieldState } from '@common/hooks';
import { notEmptyValidator } from '@common/utils';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const PickupDateReturnField: FC = () => {
  const formApi = useFormApi();
  const { value: dropoff_date } = useNonSpammyFieldState<Date>('dropoff_date');
  // const { value: pickup_date_return_validated } = useNonSpammyFieldState(
  //   'pickup_date_return_validated',
  // );

  // TO DO: We really need this initial?
  // TO DO: https://github.com/joepuzzo/informed/issues/354
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: Unreachable code error
  const dropoff_date_initial = formApi.getInitialValue('dropoff_date') as Date;

  useEffect(() => {
    if (dropoff_date) {
      formApi.setValue('pickup_date_return', dropoff_date);
    }
  }, [dropoff_date]);

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-pick-up-date-return">
      <DateField
        className={css.input}
        dropdownMode="select"
        label={t('bookingDetails.pickupDate')}
        minDate={dropoff_date || dropoff_date_initial}
        name="pickup_date_return"
        showMonthDropdown
        showYearDropdown
        validate={notEmptyValidator}
        onChange={(value) => formApi.setValue('dropoff_date_return', value)}
      />
    </div>
  );
};

export default PickupDateReturnField;
